<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-1">
            <div class="col-md-12">
              <h5 class="text-uppercase text-info mb-3">
                DATA PEMERIKSAAN PERAWAT
              </h5>
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <hr />
          <div class="row mb-5">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">tanda vital</h5>
              <FormRow
                v-for="row in formVital"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />

              <h5 class="text-uppercase text-info mb-3 mt-3">fungsional</h5>
              <FormRow
                v-for="row in formFungsional"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3">skrining gizi</h5>
              <FormRow
                v-for="row in formGizi"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <h5 class="text-uppercase text-info mb-3 mt-3">status alergi</h5>
              <FormRow
                v-for="row in formAlergi"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3 mt-3">
                skrining resiko jatuh dan cidera
              </h5>
              <FormRow
                v-for="row in formResiko"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/ralan')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import {
  setPatientIntro,
  setRawatIntro,
  validateForms,
  resetForms,
  getFullUrl,
} from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import {
  upperForm,
  formVital,
  formGizi,
  formFungsional,
  formAlergi,
  formResiko,
  today,
  time,
} from "@/data/RalanFormPetugas.js";

export default {
  name: "RalanFormPetugas",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: {
        title: "Ubah Data Pemeriksaan Perawat",
        backBtn: "",
        actionBtn: [],
        breadcrumb: [
          { title: "Detail Rawat Jalan", link: "" },
          { title: "Ubah Data Pemeriksaan Perawat", active: true },
        ],
      },
      upperForm: upperForm,
      formVital: formVital,
      formFungsional: formFungsional,
      formGizi: formGizi,
      formAlergi: formAlergi,
      formResiko: formResiko,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      idFormPetugas: "",
      formSet: {
        no_rawat: "",
        id_petugas: "",
        tgl_periksa: today,
        jam_periksa: time,
        suhu: "",
        tkn_darah: "",
        nadi: "",
        respirasi: "",
        gdse: "",
        berat: "",
        tinggi: "",
        alat_bantu: "",
        prothesa: "",
        cct_tubuh: "",
        adl: "",
        alg_obat: "",
        alg_makanan: "",
        rsk_a: "",
        rsk_b: "",
        tkt_resiko: "",
        skala_nyeri: "0",
        rpd: "",
        keluhan: "",
        soap: "",
        file_persetujuan: "",
        file_penandaan_operasi: "",
        file_serah_terima: "",
      },
      file_persetujuan_lama: "",
      file_penandaan_operasi_lama: "",
      file_serah_terima_lama: "",
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      resetForms(
        this.formSet,
        [
          this.upperForm,
          this.formVital,
          this.formFungsional,
          this.formGizi,
          this.formAlergi,
          this.formResiko,
        ],
        true,
        this.handleChange
      );
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      this.errors = [];
      // let formData = new FormData();
      var self = this;
      // let body = "";
      let body = new FormData();
      let { forms, validity } = validateForms(
        this.formSet,
        [
          this.upperForm,
          this.formVital,
          this.formFungsional,
          this.formGizi,
          this.formAlergi,
          this.formResiko,
        ],
        this,
        false
      );
      let valid = validity;
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          // formData.append(key, self.formSet[key]);
          if (self.formSet[key]) {
            if (
              !(
                [
                  "file_persetujuan",
                  "file_penandaan_operasi",
                  "file_serah_terima",
                ].indexOf(key) > -1 && self.formSet[key] == self[key + "_lama"]
              )
            ) {
              body.append(key, self.formSet[key]);
            }
          }
        });
        //console.log(body);
        try {
          // let result = await this.$store.state.HTTP_ENC.put(
          //   `/ralan/pemeriksaan/petugas/${this.idFormPetugas}`,
          //   body
          // );
          let result = await this.$store.state.HTTP.post(
            `/ralan/pemeriksaan/petugas/${this.idFormPetugas}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.$router.push(`/ralan/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [
          this.upperForm,
          this.formVital,
          this.formFungsional,
          this.formGizi,
          this.formAlergi,
          this.formResiko,
        ],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
        if (e.target.name == "rsk_a" || e.target.name == "rsk_b") {
          ////console.log('masuk ke logic ini');
          let a = this.formSet["rsk_a"];
          let b = this.formSet["rsk_b"];
          this.formSet["tkt_resiko"] =
            a == "1" && b == "1" ? 3 : a == "0" && b == "0" ? 1 : 2;
          this.updateForm();
        }
      }
      //console.log(e.target.name+':'+e.target.value);
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [
        this.upperForm,
        this.formVital,
        this.formFungsional,
        this.formAlergi,
        this.formResiko,
        this.formGizi,
      ].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              if (column.regex) {
                //console.log(column.regex);
                console.log(column.name);
                console.log(self.formSet[column.name]);
                if (
                  String(self.formSet[column.name] || "").match(column.regex)
                ) {
                  column.error = "";
                } else {
                  column.error = column.regexError;
                  valid = false;
                }
              } else {
                column.error = "";
              }
            }
            if (self.formSet[column.name]) {
              if (column.type == "file" || column.type == "image") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.formVital = forms[1];
      this.formFungsional = forms[2];
      this.formAlergi = forms[3];
      this.formResiko = forms[4];
      this.formGizi = forms[5];
      //console.log(self.formSet);
      return valid;
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.upperForm[0].columns[2].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
          this.upperForm[0].columns.splice(2, 1, this.upperForm[0].columns[2]);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    displayDataFetch: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/petugas/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          let data = result.data.rln_periksa_ptg;
          //console.log(data);
          // this.formSet=pasien;
          let self = this;
          Object.keys(this.formSet).forEach(function(key) {
            self.formSet[key] = data[key];
          });

          this.updateForm();
          //console.log(data);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayData: async function(data) {
      let self = this;
      console.log(data);
      this.idFormPetugas = data.id;
      Object.keys(this.formSet).forEach(function(key) {
        if (
          [
            "file_persetujuan",
            "file_penandaan_operasi",
            "file_serah_terima",
          ].indexOf(key) > -1
        ) {
          var url = getFullUrl(self.$store.state.baseStorageURL, data[key]);
          self[key + "_lama"] = url;
          self.formSet[key] = url;
        } else {
          self.formSet[key] = data[key];
        }
      });
      //console.log(self.formSet);
      this.updateForm();
    },

    updateForm() {
      let self = this;
      let forms = [
        this.upperForm,
        this.formVital,
        this.formGizi,
        this.formFungsional,
        this.formAlergi,
        this.formResiko,
      ].map(function(form) {
        form = form.map(function(row, index) {
          row.columns = row.columns.map(function(column) {
            //console.log(self.formSet[column.name]);
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              if (
                ["file", "image"].indexOf(column.type) > -1 &&
                self.formSet[column.name] != self[column.name + "_lama"]
              ) {
                self.updateImage(
                  self.formSet[column.name],
                  column,
                  self.formResiko,
                  index
                );
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.formVital = forms[1];
      this.formGizi = forms[2];
      this.formFungsional = forms[3];
      this.formAlergi = forms[4];
      this.formResiko = forms[5];
    },
    updateImage: async function(file, column, form, rowIndex) {
      column.value = await new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = (e) => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      ////console.log(column.value);
      ////console.log(this.leftForm);
      form.splice(rowIndex, 1, form[rowIndex]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = "/ralan/detail/" + this.$route.params.id;
    this.data.breadcrumb[0].link = "/ralan/detail/" + this.$route.params.id;
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        if (result.data.rln_periksa_ptg) {
          if (result.data.jen_periksa == "Kontrol Lanjutan") {
            this.formResiko[5].columns[0].type = "textarea";
          } else {
            this.formResiko[5].columns[0].type = "hidden";
          }
          this.displayData(result.data.rln_periksa_ptg);
        } else {
          this.$router.push(`/ralan/form-petugas/${this.$route.params.id}`);
        }
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchNurses();
  },
};
</script>
